"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppEvent = exports.AppEventEmoji = exports.AppEventLevel = exports.AppEventType = void 0;
var AppEventType;
(function (AppEventType) {
    AppEventType["login"] = "login";
    AppEventType["other"] = "other";
})(AppEventType = exports.AppEventType || (exports.AppEventType = {}));
var AppEventLevel;
(function (AppEventLevel) {
    AppEventLevel["info"] = "info";
    AppEventLevel["warning"] = "warning";
    AppEventLevel["error"] = "error";
})(AppEventLevel = exports.AppEventLevel || (exports.AppEventLevel = {}));
var AppEventEmoji;
(function (AppEventEmoji) {
    AppEventEmoji["rocket"] = ":rocket:";
    AppEventEmoji["exclamation"] = ":exclamation:";
})(AppEventEmoji = exports.AppEventEmoji || (exports.AppEventEmoji = {}));
class AppEvent {
    withEnvironment(environment) {
        this.environment = environment;
        return this;
    }
    withUrl(url) {
        this.url = url;
        return this;
    }
    withEmoji(emoji) {
        this.emoji = emoji;
        return this;
    }
    withAtt() {
        this.att = true;
        return this;
    }
    withColor(color) {
        this.color = color;
        this.att = true;
        return this;
    }
    static info(message, type = AppEventType.other) {
        return AppEvent.withLevel(message, AppEventLevel.info, type);
    }
    static warning(message, type = AppEventType.other) {
        return AppEvent.withLevel(message, AppEventLevel.warning, type).withColor('#f07c1d');
    }
    static error(message, type = AppEventType.other) {
        return AppEvent.withLevel(message, AppEventLevel.error, type).withColor('#f02b1d');
    }
    static withLevel(message, level, type = AppEventType.other) {
        const event = new AppEvent();
        event.appEventType = type;
        event.level = level;
        event.message = message;
        event.timestamp = Date.now();
        return event;
    }
}
exports.AppEvent = AppEvent;
